import RadioGroupInput from 'shared/components/molecules/RadioGroupInput/RadioGroupInput';

export default RadioGroupInput;
